import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, ClothIcon } from "../icons";

export default function RequestDetailsModal({
  open,
  onClose,
  requestData = {},
}) {
  console.log("Request Data:", requestData);

  const formatDateTime = (date) =>
    new Date(date).toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

  useEffect(() => {
    // any future initialization when open
  }, [open, requestData]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="!max-w-[750px] w-full md:w-[95vw] pt-5 pb-6 px-0 max-h-[95vh] overflow-y-auto"
      centered={false}
    >
      <div className="w-full">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 pl-9 pr-6">
          <div>
            <p className="text-xl font-bold text-black leading-6">
              Request Details{" "}
              <span className="ml-2.5 text-sm font-normal text-[#ACACAC]">
                {requestData._id}
              </span>
            </p>
            <p className="text-sm text-black leading-6">
              Full requisition information and history
            </p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-6 sm:pt-8 px-4 sm:px-9 pb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Left Column - Item Info */}
            <div className="bg-[#D8D8D81A] border border-[#EAEAEA] rounded-[22px] p-4 sm:p-5">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-[#6D4E8A1F] flex items-center justify-center shrink-0 overflow-hidden">
                  {requestData?.item?.itemPicture?.secure_url ||
                    requestData?.centralCampusInventoryItemId?.itemId?.itemPicture
                      ?.secure_url ? (
                    <img
                      src={
                        requestData?.item?.itemPicture?.secure_url ||
                        requestData?.centralCampusInventoryItemId?.itemId
                          ?.itemPicture?.secure_url
                      }
                      alt="Item"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <ClothIcon color="#000" />
                  )}
                </div>
                <div>
                  <p className="text-sm leading-4 text-[#787878] mb-1">
                    Item Requested
                  </p>
                  <p className="text-xl font-bold leading-6 text-black">
                    {requestData?.item?.name ||
                      requestData?.centralCampusInventoryItemId?.itemId?.name ||
                      "Unknown Item"}
                  </p>
                </div>
              </div>

              <div className="flex flex-col gap-3 mt-auto">
                <div className="flex justify-between gap-4 text-sm leading-snug">
                  <p className="text-[#787878] shrink-0">Campus</p>
                  <p className="text-black text-right font-medium">
                    {requestData?.requestedCampusId?.name || "N/A"}
                  </p>
                </div>
                <div className="flex justify-between gap-4 text-sm leading-snug items-center">
                  <p className="text-[#787878] shrink-0">Requested By</p>
                  <div className="text-right">
                    <p className="text-black font-medium">
                      {requestData?.requestedBy?.name}
                    </p>
                    <p className="text-[11px] text-[#787878]">
                      {requestData?.requestedBy?.email}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* ✅ Yahan Left Column ka closing div sahi jagah par hai */}

            {/* Right Column - Status & Dates */}
            <div className="bg-[#D8D8D81A] border border-[#EAEAEA] rounded-[22px] p-4 sm:p-5 flex flex-col justify-between">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-xl bg-[#EEFFEA] flex items-center justify-center shrink-0">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.713 16.713C12.9043 16.521 13 16.2833 13 16C13 15.7167 12.904 15.4793 12.712 15.288C12.52 15.0967 12.2827 15.0007 12 15C11.7173 14.9993 11.48 15.0953 11.288 15.288C11.096 15.4807 11 15.718 11 16C11 16.282 11.096 16.5197 11.288 16.713C11.48 16.9063 11.7173 17.002 12 17C12.2827 16.998 12.5203 16.903 12.713 16.713ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12C21.998 13.3827 21.7353 14.6827 21.212 15.9C20.6887 17.1173 19.9763 18.1757 19.075 19.075C18.1737 19.9743 17.1153 20.687 15.9 21.213C14.6847 21.739 13.3847 22.0013 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                      fill="#427316"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-sm leading-4 text-[#787878]">
                    Current Status
                  </p>
                  <div
                    className={`mt-1 rounded-[10px] text-base px-5 py-0.5 inline-block ${requestData.status === "pending_vp" ||
                      requestData.status === "pending_central"
                      ? "bg-[#F6E8AD] text-[#986012]"
                      : requestData.status === "approved_central"
                        ? "bg-[#E5FFF6] text-[#2C765C]"
                        : requestData.status === "recieved"
                          ? "bg-[#D6EAFE] text-[#0052CC]"
                          : requestData.status === "rejected_vp" ||
                            requestData.status === "rejected_central"
                            ? "bg-[#FFBFBF] text-[#F6200D]"
                            : "bg-[#EAEAEA] text-[#7A7A7A]"
                      }`}
                  >
                    {requestData.status === "pending_vp"
                      ? "Pending VP"
                      : requestData.status === "pending_central"
                        ? "Pending Central"
                        : requestData.status === "approved_central"
                          ? "Approved / Dispatch"
                          : requestData.status === "recieved"
                            ? "Received"
                            : requestData.status === "rejected_vp"
                              ? "Rejected (VP)"
                              : requestData.status === "rejected_central"
                                ? "Rejected (Central)"
                                : requestData.status || "N/A"}
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-3 mt-auto">
                <div className="flex justify-between gap-4 items-center">
                  <p className="text-[#787878] text-sm leading-snug shrink-0">
                    Created At
                  </p>
                  <p className="text-black text-xs font-medium text-right">
                    {formatDateTime(requestData.createdAt)}
                  </p>
                </div>
                <div className="flex justify-between gap-4 items-center">
                  <p className="text-[#787878] text-sm leading-snug shrink-0">
                    Last Updated
                  </p>
                  <p className="text-black text-xs font-medium text-right">
                    {formatDateTime(requestData.updatedAt)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Quantity Breakdown Section */}
          <div className="mt-4 sm:mt-6 bg-gradient-to-br from-[#6D4E8A] to-[#8C6B9D] text-white rounded-[22px] p-5 sm:p-7 shadow-sm">
            <h3 className="text-lg sm:text-xl font-bold mb-6 sm:mb-8 text-white/90">
              Quantity Breakdown
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-4 border-b border-white/20 pb-6">
              <div className="text-center">
                <p className="text-sm leading-4 mb-1.5">Initial Request</p>
                <p className="text-xl font-bold leading-6">
                  {requestData.requestedQty ?? "0"}
                </p>
              </div>
              <div className="text-center">
                <p className="text-sm leading-4 mb-1.5">VP Approved</p>
                <div className="flex flex-col items-center">
                  <p className="text-xl leading-6 font-bold">
                    {requestData.status === "pending_vp" || requestData.status === "rejected_vp"
                      ? "-"
                      : (requestData.requestedQty - (requestData.vpModifiedQty || 0))}
                  </p>
                  {requestData.vpModifiedQty > 0 && requestData.status !== "pending_vp" && requestData.status !== "rejected_vp" && (
                    <p className="text-xs text-white/70 mt-1">
                      (Reduced by {requestData.vpModifiedQty})
                    </p>
                  )}
                </div>
              </div>
              <div className="text-center">
                <p className="text-sm leading-4 mb-1.5">Central Approved</p>
                <div className="flex flex-col items-center">
                  <p className="text-xl leading-6 font-bold">
                    {requestData.status === "approved_central" || requestData.status === "recieved"
                      ? requestData.issuedQty
                      : "-"}
                  </p>
                  {requestData.centralModifiedQty > 0 && (requestData.status === "approved_central" || requestData.status === "recieved") && (
                    <p className="text-xs text-white/70 mt-1">
                      (Reduced by {requestData.centralModifiedQty})
                    </p>
                  )}
                </div>
              </div>
              <div className="text-center">
                <p className="text-sm leading-4 mb-1.5">Final Issued</p>
                <p className="text-xl leading-6 font-bold">
                  {requestData.status === "approved_central" || requestData.status === "recieved"
                    ? requestData.issuedQty
                    : "-"}
                </p>
              </div>
            </div>


          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full mt-6 py-3 font-semibold text-sm text-[#4A4A4A] bg-[#F5F5F5] border border-[#E5E5E5] rounded-xl hover:bg-[#EBEBEB] hover:text-black transition-colors"
          >
            Close Details
          </button>
        </div>
      </div>
    </Modal>
  );
}
